// extracted by mini-css-extract-plugin
export var footer = "_r0-5";
export var fulfillmentInput = "_r0-0";
export var shipDateInput = "_r0-1";
export var shipmentModal = "_r0-2";
export var shipmentModalContent = "_r0-3";
export var tableContainer = "_r0-4";